module.exports = __webpack_public_path__ + "img/nahash_yes.68ded0cc.png";